import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './index.css';
import axios from 'axios';
import { ConfigurationServicePlaceholders } from 'aws-sdk/lib/config_service_placeholders';


// PRODUCTION
    const app = createApp(App)

    app.provide('curationFarm', 'D7rcu7vcufa3ptv7HmhSENktRAE1qWmvC5GfjSfgfbPY');
    app.provide('stakeFarm', '3ZCMrv5HoJrHgdCzthMpFJQqjxBGFkpGashBkvwSzXXw');
    app.provide('tokenMint', '5Emw7mifMM86nfHhyMC12p8pAW5DvWTFJeFtsP7DBHn2');
    app.provide('walletAddress', '6Y3DKHgWX5tU6S4smXt9mstrEzn4krEyibqbn16LgFe7');

    app.use(router).mount('#app');

// TESTING
  // axios.get(`http://localhost:8081/read_settings.php`).then((response: any) => {
    // let appData = response.data;
    // const app = createApp(App)

    // app.provide('curationFarm', 'GNSuYXSjj5Dh5H9dMUEr9AesXNci8jjUmZuD2JGsBgQb');
    // app.provide('stakeFarm', 'GPTsDfNfNh6NSZciWyPD6zNLJRBTZJuLKpmucP1afQGW');
    // app.provide('tokenMint', 'DEMYY7hKjaD3JfMFgkB9GqdZi14kyimtSBgjho7DU2xc');
    // app.provide('walletAddress', 'HxDkgPwPfo5C6gYq5PdnqGULrLFh7jPXv7zkVYeENoB2');

    // app.use(router).mount('#app');
  // });

